// import axios from "axios";
import Properties from "../properties";
import apiClient from "../plugins/axios-instance";

// const API_URL = "https://api." + Properties.DOMAIN_URL + "/poin-gifts/gifts";
const API_URL =
    "https://backend." + Properties.DOMAIN_URL + "/poin-gift/api/gifts";

export default class GiftPoinAPIService {
    constructor() {}
    config = this.$session.get("jwt");
    headers = {};

    static getAll = (limit, page) =>
        apiClient.get(API_URL + "/limit/" + limit + "?page=" + page, {
        });

    static filter = (body, page) =>
        apiClient.get(API_URL + "/searching/filter-gift?page=" + page, {
            params: body,
        });

    static filterOnPeriode = () =>
        apiClient.get(API_URL + "/filter/periode", {
            // params: body,
        });

    static getByID = (id) =>
        apiClient.get(API_URL + "/" + id, {
        });

    static edit = (id, gift) =>
        apiClient.post(API_URL + "/" + id, gift, {
        });
    static create = (gift) => {
        return apiClient.post(API_URL + "/", gift, {
        });
    };
    static delete = (id, nik) =>
        apiClient.delete(API_URL + "/" + id, {
            data: { user_update: nik },
        });
}
